import { useEffect } from "react";
import { useAuth } from "./use-auth.js";
import { useRouter } from "./use-router.js";

export function useRequireAuth(redirectUrl = "/login") {
  const auth = useAuth();
  const router = useRouter();

  // If auth.isAuthenticated is false that means we're not
  // logged in and should redirect.
  useEffect(() => {
    if (!auth.isAuthenticated || auth.isAuthenticated === false) {
      router.push(redirectUrl);
    }
  }, [auth, router, redirectUrl]);

  return auth;
}
